module.exports = __webpack_public_path__ + "img/p72.14b887fb.jpg";